export default {
  title: "Vérifiez votre email",
  verifying: {
    title: "Vérification de votre email",
    subtitle: "Veuillez patienter pendant que nous vérifions votre adresse email...",
  },
  sending: {
    title: "Envoi de l'email de vérification",
    subtitle: "Veuillez patienter pendant que nous envoyons l'email de vérification...",
  },
  sent: {
    title: "Email de vérification envoyé",
    confirmationMessage: {
      beforeEmail: "Nous avons envoyé un lien de confirmation à ",
      afterEmail: "",
    },
    instruction:
      "Veuillez consulter votre boîte de réception et cliquer sur le lien pour activer votre compte",
    troubleMessage:
      "Vous n'avez pas reçu l'email ? Vérifiez votre dossier spam ou cliquez sur « Renvoyer » ci-dessous",
    limitNote: "Remarque : Vous pouvez renvoyer l'email de vérification jusqu'à 3 fois par jour",
  },
  resent: {
    title: "Email de vérification renvoyé",
    confirmationMessage: {
      beforeEmail: "Nous avons renvoyé le lien de confirmation à ",
      afterEmail: "",
    },
    instruction:
      "Veuillez consulter votre boîte de réception et cliquer sur le lien pour activer votre compte",
    troubleMessage:
      "Si vous ne l'avez toujours pas reçu, vérifiez vos dossiers spam/indésirable ou réessayez plus tard",
    limitNote: "Remarque : Vous pouvez renvoyer l'email de vérification jusqu'à 3 fois par jour",
  },
  success: {
    title: "Email vérifié avec succès",
    subtitle: "Votre email a été vérifié. Vous pouvez maintenant vous connecter à votre compte.",
    button: "Aller à la connexion",
    autoRedirectMessage: "Redirection vers le tableau de bord dans {seconds} secondes...",
  },
  error: {
    title: "Échec de la vérification de l'email",
    subtitle:
      "Une erreur s'est produite lors de la vérification. Veuillez réessayer ultérieurement.",
  },
  resending: "Renvoi en cours...",
  resendAvailableIn: "Renvoi disponible dans {seconds}s",
  resendVerificationEmail: "Renvoyer l'email de vérification",
  verificationFailed: "Échec de la vérification de l'email",
  verificationError: "Une erreur s'est produite lors de la vérification de l'email",
  pleaseWait: "Veuillez patienter {seconds} secondes avant de renvoyer",
  dailyLimitReached: "Limite quotidienne de renvoi atteinte. Réessayez demain.",
  resentSuccess: "Email de vérification renvoyé avec succès",
  resendFailed: "Échec du renvoi de l'email de vérification",
  invalidRequest: "Demande invalide",
  remainingAttempts: "Il vous reste {count} tentatives aujourd'hui",
};
